<template>
    <div 
        class="table-multiline"
        :class="{'preloader-content': isPreloader}"
    >
        <div
            v-if="isPreloader"
            class="preloader fa fa-circle-o-notch fa-spin">
        </div>
        <table v-if="Object.keys(tableDataBuffer).length !== 0">
            <thead>
                <tr class="table-tr__section">
                    <th :colspan="rowTitleLimitIndex + 1" class="table-multiline__td-name" style="text-align: right">
                        ДАТЫ СРЕЗОВ:
                    </th>
                    <th
                        v-for="(columnKey, columnIndex) in Object.keys(tableDataColumns)"
                        :key="columnIndex"
                        :colspan="colspan"
                        class="table-multiline__td-name"
                    >
                        {{tableDataColumns[columnKey]}}
                    </th> 
                </tr>
                <tr>
                    <th
                        v-for="(subColumnKey, subColumnIndex) in Object.keys(tableDataSubColumns)"
                        :key="subColumnIndex"
                        :class="{
                            'table-multiline__td-name': (subColumnIndex === rowTitleLimitIndex) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1)),
                            'table-multiline__td-line': (subColumnKey.includes('profit_without_tax')) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1))
                            }"
                        :style="getStyleCell(subColumnKey)"
                        width="130"
                    >
                        <table-header
                            :isSort="isSort && Object.keys(columnsSort).includes(subColumnKey)"
                            :sortState="sortColumn === subColumnKey ? sortState : 0"
                            :title="tableDataSubColumns[subColumnKey]"
                            @onToggleSort="onToggleSort($event, subColumnKey)"
                        />
                    </th>
                </tr>
            </thead>
            <tbody v-if="!isObjectCell">
                <template
                    v-for="(rowKey, rowKeyIndex) in tableDataRows.keys()"
                >
                    <tr
                        :key="rowKeyIndex"
                    >
                        <td
                            v-for="(subColumnKey, subColumnIndex) in Object.keys(tableDataSubColumns)"
                            :key="subColumnIndex"
                            :class="{
                                'table-multiline__td-number': typeof tableDataRows.get(rowKey)[subColumnKey] === 'number',
                                'preloader-content': preloaderKeyRow == rowKey,
                                'table-multiline__td-name' : (subColumnIndex === rowTitleLimitIndex) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1)),
                                'table-multiline__td-line' : (subColumnKey.includes('profit_without_tax')) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1)),
                            }"
                        >
                            <i
                                v-if="preloaderKeyRow === rowKey && subColumnIndex <= rowTitleLimitIndex"
                                class="table_plus fa fa-circle-o-notch fa-spin"
                                :style="{'font-size': `12px`}"
                            >
                            </i>
                            <i
                                v-if="tableDataOptions[rowKey] && tableDataOptions[rowKey].multiple === true && subColumnIndex <= rowTitleLimitIndex && preloaderKeyRow !== rowKey"
                                class="table_plus"
                                :class="{
                                    'fa fa-plus': !activeRows.includes(rowKey),
                                    'fa fa-minus': activeRows.includes(rowKey)
                                }"
                                @click.stop="onClickTableItem(rowKey)"
                            >
                            </i>
                            {{
                                // typeof tableDataRows[rowKey][subColumnKey] === 'number' ? tableDataRows[rowKey][subColumnKey].toLocaleString('ru-RU') : tableDataRows[rowKey][subColumnKey]
                                typeof tableDataRows.get(rowKey)[subColumnKey] === 'number' ? tableDataRows.get(rowKey)[subColumnKey].toLocaleString('ru-RU') : tableDataRows.get(rowKey)[subColumnKey]
                            }}
                        </td>
                    </tr>
                    <template v-if="Object.keys(subrowsBuffer).includes(rowKey) && activeRows.includes(rowKey)">
                        <tr
                            v-for="(subRow, subRowIndex) in subrowsBuffer[rowKey].keys()"
                            :key="`${rowKey}_${subRowIndex}`"
                            class="tr__sub"
                        >
                            <td
                                v-for="(subColumnKey, subColumnIndex) in Object.keys(tableDataSubColumns)"
                                :key="`${rowKey}_${subColumnKey}`"
                                :class="{
                                    'table-multiline__td-number': typeof subrowsBuffer[rowKey].get(subRow)[subColumnKey] === 'number',
                                    'table-multiline__td-name' : (subColumnIndex === rowTitleLimitIndex) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1)),
                                    'table-multiline__td-line' : (subColumnKey.includes('profit_without_tax')) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1)),
                                }"
                            >
                                {{
                                    typeof subrowsBuffer[rowKey].get(subRow)[subColumnKey] === 'number' ? subrowsBuffer[rowKey].get(subRow)[subColumnKey].toLocaleString('ru-RU') : subrowsBuffer[rowKey].get(subRow)[subColumnKey]
                                }}
                            </td>
                        </tr>
                    </template>
                </template>
            </tbody>
            <tbody v-if="isObjectCell">
            <template
                    v-for="(rowKey, rowKeyIndex) in tableDataRows.keys()"
            >
                <tr
                        :key="rowKeyIndex"
                >
                    <td
                            v-for="(subColumnKey, subColumnIndex) in Object.keys(tableDataSubColumns)"
                            :key="subColumnIndex"
                            :class="{
                                'preloader-content': preloaderKeyRow == rowKey,
                                'table-multiline__td-number': subColumnIndex > rowTitleLimitIndex,
                                'table-multiline__td-name' : (subColumnIndex === rowTitleLimitIndex) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1)),
                                'table-multiline__td-line' : (subColumnKey.includes('profit_without_tax')) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1)),
                            }"
                    >
                        <i
                                v-if="preloaderKeyRow === rowKey && subColumnIndex === 0"
                                class="table_plus fa fa-circle-o-notch fa-spin"
                                :style="{'font-size': `12px`}"
                        >
                        </i>
                        <i
                                v-if="tableDataOptions[rowKey] && tableDataOptions[rowKey].multiple === true && subColumnIndex === 0 && preloaderKeyRow !== rowKey"
                                class="table_plus"
                                :class="{
                                    'fa fa-plus': !activeRows.includes(rowKey),
                                    'fa fa-minus': activeRows.includes(rowKey)
                                }"
                                @click.stop="onClickTableItem(rowKey)"
                        >
                        </i>
                        {{ (subColumnIndex > rowTitleLimitIndex) ? '' : getCellValue(tableDataRows.get(rowKey)[subColumnKey], subColumnIndex, 'val') }}
                        <span v-if="subColumnIndex > rowTitleLimitIndex" class="table-multiline__cell-val">
                            {{
                                getCellValue(tableDataRows.get(rowKey)[subColumnKey], subColumnIndex)
                            }}
                        </span>
                        <span 
                            v-if="typeof tableDataRows.get(rowKey)[subColumnKey] !== 'undefined' && subColumnIndex !== 0" 
                            class="table-multiline__cell-diff"
                            :class="{'table-multiline__cell-diff_negative':  isCellDiffNegative(tableDataRows.get(rowKey)[subColumnKey], subColumnIndex, 'diff')}"
                        >
                            {{
                                getCellValue(tableDataRows.get(rowKey)[subColumnKey], subColumnIndex, 'diff')
                            }}
                        </span>
                    </td>
                </tr>
                <template v-if="Object.keys(subrowsBuffer).includes(rowKey) && activeRows.includes(rowKey)">
                    <tr
                            v-for="(subRow, subRowIndex) in subrowsBuffer[rowKey].keys()"
                            :key="`${rowKey}_${subRowIndex}`"
                            class="tr__sub"
                    >
                        <td
                                v-for="(subColumnKey, subColumnIndex) in Object.keys(tableDataSubColumns)"
                                :key="`${rowKey}_${subColumnKey}`"
                                :class="{
                                    'table-multiline__td-number': subColumnIndex > rowTitleLimitIndex,
                                    'table-multiline__td-name' : (subColumnIndex === rowTitleLimitIndex) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1)),
                                    'table-multiline__td-line' : (subColumnKey.includes('profit_without_tax')) && (subColumnIndex !== (Object.keys(tableDataSubColumns).length - 1)),
                                }"
                        >
                            <span class="table-multiline__cell-val">
                                {{
                                    getCellValue(subrowsBuffer[rowKey].get(subRow)[subColumnKey], subColumnIndex)
                                }}
                            </span>
                            <span 
                                v-if='typeof subrowsBuffer[rowKey].get(subRow)[subColumnKey] !== `undefined`' 
                                class="table-multiline__cell-diff"
                                :class="{'table-multiline__cell-diff_negative':  isCellDiffNegative(subrowsBuffer[rowKey].get(subRow)[subColumnKey], subColumnIndex, 'diff')}"
                            >
                                {{
                                    getCellValue(subrowsBuffer[rowKey].get(subRow)[subColumnKey], subColumnIndex, 'diff')
                                }}
                            </span>
                        </td>
                    </tr>
                </template>
            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import TableHeader from './TableHeader';
import mixinTable from '../../mixins/mixinTable';
export default {
    name: 'TableMultiline',
    components: {
        TableHeader
    },
    mixins: [
        mixinTable
    ],
    /**
     * входные данные компонента
     * @property {object} tableData - данные таблицы
     * @property {object} subrows - подстроки
     * @property {array} activeRows - активные родительские строки
     * @property {number} colspan - колличество подячеек
     * @property {boolean} isPreloader - условие показа прелоадера
     * @property {boolean} isSort - вкл/откл сортировку
     * @property {object} columnsSort - колонки которые можно сортировать
     * @property {Object} columnsStyles - стили колонок
     * @property {boolean} isObjectCell - является ли значение ячейки объектом
     */
    props: {
        tableData: {
            type: Object,
            default: () => ({})
        },
        subrows: {
            type: Object,
            default: () => ({})
        },
        activeRows: {
            type: Array,
            default: () => ([])
        },
        colspan: {
            type: Number,
            default: 0
        },
      rowTitleLimitIndex: {
        type: Number,
        default: 0
      },
        isPreloader: {
            type: Boolean,
            default: false
        },
        preloaderKeyRow: {
            type: String,
            default: ''
        },
        isSort: {
            type: Boolean,
            default: false
        },
        columnsSort: {
            type: Object,
            default: () => ({})
        },
        columnsStyles: {
            type: Object,
            default: () => ({})
        },
        isObjectCell: {
            type: Boolean,
            default: false
        },
    },
    /**
     * данные компонента
     * @property {object} tableDataBuffer - буфферные данные таблицы
     * @property {object} subrowsBuffer - буфферные данные подстрок
     */
    data: () => ({
        tableDataBuffer: {},
        subrowsBuffer: {},
    }),
    computed: {
        /**
         * опции
         * @returns {object}
         */
        tableDataOptions() {
            let {options = {}} = this.tableDataBuffer;
            return options;
        },
        /**
         * колонки
         * @returns {object}
         */
        tableDataColumns() {
            let {columns = {}} = this.tableDataBuffer;
            return columns;
        },
        /**
         * подколонки
         * @returns {object}
         */
        tableDataSubColumns() {
            let {subColumns = {}} = this.tableDataBuffer;
            return subColumns;
        },
        /**
         * строки
         * @returns {map}
         */
        tableDataRows() {
            let {rows = new Map()} = this.tableDataBuffer;
            return rows;
        },
    },
    watch: {
        /**
         * следим за обновлением табличных данных и обновляем буффер
         */
        tableData: function() {
            this.tableDataBuffer = Object.assign({}, this.tableData);
            this.sortState = 0;
            this.sortColumn = '';
        },
        /**
         * следим за обновлением подстрок и обновляем буффер
         */
        subrows: function () {
            this.subrowsBuffer = Object.assign({}, this.subrows);
            if (this.sortState !== 0) {
                this.sortSubrows();
            }
        }
    },
    methods: {
        /**
         * получить стиль ячейки
         * @param {string} columnKey - ключь колонки
         * @returns {Object}
         */
        getStyleCell(columnKey = '') {
            let styleCell = this.columnsStyles.hasOwnProperty(columnKey) ? this.columnsStyles[columnKey] : {};
            return styleCell;
        },
        /**
         * Событие клика по иконке раскрыть/скрыть
         * @param {string} rowKey - ключ строки
         */
        onClickTableItem(rowKey) {
            this.$emit('onClickTableItem', rowKey);
        },
        /**
         * переключение режима сортировки
         * @param {string} currentSortState - текущее состояние режима сортировки
         * @param {string} column - колонка по которой сортируем
         */
        onToggleSort(currentSortState, column) {
            if(currentSortState === Object.keys(this.sortStates).length - 1)
                this.sortState = 0;
            else
                this.sortState = currentSortState + 1;
            this.sortColumn = column;
            let typeSort = this.sortStates[this.sortState].type;
            let rowsNoSort = new Map([...this.tableDataRows].filter(row => row[0] == 'sum'));
            let rowsForSort = new Map([...this.tableDataRows].filter(row => row[0] !== 'sum'));
            if (typeSort === 'none') {
                this.tableDataBuffer = {...this.tableData};
                this.subrowsBuffer = {...this.subrows};
            }
            else {
                if (this.columnsSort[column].typeColumn === 'Number') {
                    let filteredRows = this.sortNumberMap(typeSort, rowsForSort, column, this.isObjectCell);
                    this.tableDataBuffer = {
                        ...this.tableDataBuffer,
                        rows: new Map ([...rowsNoSort, ...filteredRows])
                    };
                    this.sortSubrows();
                }
                if (this.columnsSort[column].typeColumn === 'String') {
                    let filteredRows = this.sortStringMap(typeSort, rowsForSort, column);
                    this.tableDataBuffer = {
                        ...this.tableDataBuffer,
                        rows: new Map ([...rowsNoSort, ...filteredRows]) 
                    };
                    this.sortSubrows();
                }
            }
        },
        /**
         * отсортировать подстроки
         */
        sortSubrows() {
            let column = this.sortColumn;
            let typeColumn = this.columnsSort[column].typeColumn
            let typeSort = this.sortStates[this.sortState].type;
            let newSubrows = {};
            Object.keys(this.subrowsBuffer).forEach((subrow) => {
                if (typeColumn === 'Number') {
                    newSubrows[subrow] = this.sortNumberMap(typeSort, this.subrowsBuffer[subrow], column, this.isObjectCell);
                }
                if (typeColumn === 'String') {
                    newSubrows[subrow] = this.sortStringMap(typeSort, this.subrowsBuffer[subrow], column);
                }
            });
            this.subrowsBuffer = {...newSubrows};
        },
        /**
         *  проверяем число и присваиваем цвет
         * @param diff
         * @returns {string}
         */
        getColor(diff){
            if(diff < 0){
                return "color:red";
            }
            if(diff === 0){
                return "color:#cccccc";
            }
            if(diff > 0){
                return "color:green";
            }
        },
        isCellDiffNegative(cell, subColumnIndex, key = 'val') {
            if (key === 'diff') {
                let value = this.getCellValue(cell, subColumnIndex, key);
                if (typeof value !== 'undefined') {
                    let spltValue = value.replace(/\s/g, '');
                    return Number(spltValue) < 0 ? true : false;
                }
                else
                    return false;
            }
            else
                return false;
        },
        /**
         * получение значения в зависимости от содержимого ячейки
         * **/
        getCellValue(cell, subColumnIndex, key = 'val'){
          // console.log(debug);
            let cell_value;
            if(typeof cell === "undefined"){
                return cell;
            }
            if(key === 'diff' && subColumnIndex <= this.rowTitleLimitIndex){
                return '';
            }
            if(subColumnIndex > this.rowTitleLimitIndex){
                cell_value = typeof cell[key] === 'number' ? cell[key].toLocaleString('ru-RU') : cell[key];
            }else {
                cell_value = typeof cell === 'number' ? cell.toLocaleString('ru-RU') : cell;
            }
            return cell_value;
        },
        /**
         * Проверка ячейки на тип число
         * @param cell
         * @param key
         * @returns {boolean}
         */
        isNumber(cell, key = 'val')
        {
            let flag = false;
            if(
                typeof cell === 'number'
                || (
                    typeof cell !== 'undefined'
                    && typeof cell[key] === 'number'
                )
            ){
                flag = true;
            }
            return flag;
        }
    }
}
</script>

<style lang="scss" scoped>
    .table-multiline {
        position: relative;
        overflow-x: auto;
    }
    table {
        width: 100%;
        border-radius: 10px;
        overflow: hidden;
        border-collapse: collapse;
        border-spacing: 0;
    }

    thead th,
    tbody td {
        border-bottom: 1px solid #f5f7f9;
    }

    thead th,
    tbody td {
        padding: 16px 14px;
    }

    thead th {
        text-align: left;
        font-weight: bold;
        text-transform: uppercase;
        color: #000;
        letter-spacing: 0.07em;
        word-break: break-all;
        font-size: 0.65em;
    }

    .table-treeview__th-container {
        cursor: pointer;
    }

    thead {
        border-bottom: 3px solid #f5f7f9;
    }

    .table-tr__section {
        background: #f5f7f9;
    }

    thead th.table-multiline__td-name,
    tbody td.table-multiline__td-name {
        border-right: 3px solid #f5f7f9;
        width: 300px;
        white-space: nowrap;
    }

    thead th.table-multiline__td-line,
    tbody td.table-multiline__td-line {
        border-right: 3px solid #f5f7f9;
        width: 300px;
    }

    tbody tr.tr__sub {
        background: #fbfbfb;
    }

    tbody tr:last-child td {
        border-bottom: 0;
    }

    tbody tr.tr__sub.tr__sub-two {
        background: #fff;
    }

    tbody tr.tr__sub.tr__sub-three {
        background: #fff;
    }

    tbody tr.tr__sub td:first-child {
        padding-left: 36px;
    }

    tbody tr.tr__sub.tr__sub-two td:first-child {
        padding-left: 64px;
    }

    tbody tr.tr__sub.tr__sub-three td:first-child {
        padding-left: 93px;
    }

    tbody tr:hover {
        background: #f5f7f9 !important;
    }

    .table-multiline__td-number {
        text-align: right;
        position: relative;
        white-space: nowrap;
    }

    .table-multiline__cell-val {
        display: block;
    }

    .table-multiline__cell-diff {
        display: block;
        font-size: 12px;
        color: #b0b1b4;
        opacity: 1;
        visibility: visible;
        // position: absolute;
        right: 14px;
        bottom: 4px;
    }

    .table-multiline__cell-diff_negative {
        color: #f39b9b
    }

    // tbody tr:hover .table-multiline__cell-diff {
    //     opacity: 1;
    //     visibility: visible;
    // }

    .table_plus {
        cursor: pointer;
        border: 1px solid #f5f7f9;
        width: 16px;
        height: 16px;
        text-align: center;
        line-height: 14px;
        border-radius: 3px;
        font-size: 10px;
        margin-right: 10px;
        color: #b0b1b4;
        background: #fff;
        transition: all 250ms;
    }

    .table_plus:hover {
        background: #fe1060;
        color: #fff;
        border-color: #fe1060;
    }

    .txt_right {
        text-align: right;
    }
    .table-treeview__th-container {
        cursor: pointer;
    }
</style>